import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SPACES } from "@/lib/site";
import { TESTIDS } from "@/constants/testIds/site";

const statusDot = (status) => {
  if (status === "Available") return "bg-[#3F7A55]";
  if (status === "Limited") return "bg-[#C4A47C]";
  return "bg-[#9A9A95]";
};

export const AvailabilitySection = () => {
  return (
    <section
      data-testid={TESTIDS.availabilitySection}
      className="bg-white border-y border-[var(--border)]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="eyebrow">Current availability</div>
            <h2 className="section-title text-[44px] md:text-[64px] mt-3 leading-[1.02] max-w-2xl">
              Suites ready to <span className="italic text-[var(--primary)]">move into</span> this month.
            </h2>
          </div>
          <Link to="/available-spaces" className="link-underline">
            View all spaces <ArrowUpRight size={15} />
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SPACES.map((s) => (
            <article
              key={s.slug}
              data-testid={TESTIDS.availabilityCard(s.slug)}
              className="hairline bg-[var(--bg)] p-7 flex flex-col"
            >
              <div className="flex items-center gap-2 text-[11px] tracking-[0.18em] uppercase text-[var(--text-muted)]">
                <span className={`inline-block w-1.5 h-1.5 rounded-full ${statusDot(s.availability)}`} />
                {s.availability}
              </div>
              <h3 className="font-serif text-[28px] mt-4 leading-tight tracking-tight">
                {s.name}
              </h3>
              <p className="text-[14px] text-[var(--text-muted)] leading-relaxed mt-2 min-h-[60px]">
                {s.short}
              </p>
              <div className="divider-rule my-6" />
              <dl className="space-y-3 text-[13px]">
                <div className="flex justify-between">
                  <dt className="text-[var(--text-muted)] tracking-wide uppercase text-[11px]">Suite size</dt>
                  <dd className="text-[var(--text-main)] font-medium">{s.suiteSize}</dd>
                </div>
                <div className="flex justify-between">
                  <dt className="text-[var(--text-muted)] tracking-wide uppercase text-[11px]">Starting at</dt>
                  <dd className="text-[var(--text-main)] font-medium">
                    {s.startingRate}
                    <span className="text-[var(--text-muted)] font-normal"> {s.rateUnit}</span>
                  </dd>
                </div>
                <div className="flex justify-between">
                  <dt className="text-[var(--text-muted)] tracking-wide uppercase text-[11px]">Capacity</dt>
                  <dd className="text-[var(--text-main)] font-medium">{s.capacity}</dd>
                </div>
              </dl>
              <div className="mt-6 flex items-center gap-2">
                <Link
                  to={`/spaces/${s.slug}`}
                  className="text-[12px] font-semibold tracking-[0.12em] uppercase text-[var(--text-main)] hover:text-[var(--primary)]"
                >
                  View details
                </Link>
                <span className="text-[var(--text-muted)]">·</span>
                <Link
                  to={`/contact?type=${encodeURIComponent(s.name)}`}
                  data-testid={TESTIDS.availabilityInquire(s.slug)}
                  className="text-[12px] font-semibold tracking-[0.12em] uppercase text-[var(--primary)] hover:text-[var(--primary-hover)]"
                >
                  Inquire
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AvailabilitySection;
